module.exports = __webpack_public_path__ + "static/media/tutorial_5.96781c70.png";